export class ChatMessage {
    id: number | null = null;
    userId: number | null = null;
    message: string = '';
    response: string = '';
    date: string = '';
}